import { NotFound } from "@components/legacy";

export default NotFound;
